import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'
import { rem } from '@mantine/core'

import { Container } from 'components/atoms/container'

export const StyledHomeWrapper = styled.div`
  overflow: visible;

  min-height: 100vh;
  .banner {
    background-color: ${theme.colors.gray100};
  }

  .home-mobile-top-ad {
    ${MediaQueries.mbDown} {
      margin-top: 24px;
    }
  }
  .center-ad {
    margin-left: auto;
    margin-right: auto;
    margin-top: 24px;
  }
  .bottom-ad {
    margin-bottom: 40px;
  }

  .article-bottom-ad {
    margin-bottom: var(--mobile-bottom-height);
    @supports (margin-bottom: env(safe-area-inset-bottom)) {
      margin-bottom: calc(
        env(safe-area-inset-bottom) + var(--mobile-bottom-height)
      );
    }
    ${MediaQueries.mbUp} {
      margin-bottom: 0px;
    }
  }
`

export const StyledHomeTrendingContainer = styled.div`
  position: relative;
  overflow: visible;
  width: 100%;
  background-color: ${theme.colors.white};
  .trending-tab {
    position: sticky;
    z-index: 2;
    top: 0;
    width: 100%;

    border-bottom: none;
    background-color: ${theme.colors.white};

    & > ul {
      width: 100%;
    }

    & > ul > li > div > p {
      ${MediaQueries.mbUp} {
        font-size: ${theme.sizes.fsHeading6};
      }
    }

    ${MediaQueries.mbUp} {
      padding: 25px 0 8px;
    }

    ${MediaQueries.mbDown} {
      padding: 4px 0 0;
    }

    & > div {
      ${MediaQueries.mbUp} {
        padding: 0 16px;
      }
    }
  }

  .trending-tab {
    top: 64px;
    transition: top 0.5s;
  }

  &[data-is-top-bar-appears='false'] {
    ${MediaQueries.mbDown} {
      .trending-tab {
        top: 0;
      }
    }
  }
  ${MediaQueries.mbUp} {
    margin-top: 24px;
  }
`
export const StyledToolsCard = styled.div`
  display: flex;
  min-width: 100%;
  max-width: 400px;
  height: 100%;
  flex-direction: column;
  padding: 0 24px;
  border-radius: ${theme.borderRadius};

  filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.04)),
    drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.06)),
    drop-shadow(0px 0px 1px rgba(0, 0, 0, 0.04));
`

export const StyledTrendingTabs = styled.div`
  display: flex;
  ${MediaQueries.mbUp} {
    gap: 18px;
    padding: 16px;
  }

  ${MediaQueries.mbDown} {
    justify-content: space-between;
    gap: 8px;
    padding: 16px 0 0 0;
  }
`

type StyledTrendingTabProps = {
  isActive: boolean
}
export const StyledTrendingTab = styled.div<StyledTrendingTabProps>`
  display: flex;
  justify-content: center;
  padding: 7px 20px;
  border-radius: 40px;
  cursor: pointer;

  ${MediaQueries.mbUp} {
    gap: 6px;
  }

  ${MediaQueries.mbDown} {
    width: calc(50% - 4px);
    gap: 4px;
  }

  ${(props: StyledTrendingTabProps) =>
    props.isActive &&
    `
    background: ${theme.colors.primary50};
    p {
      color: ${theme.colors.primaryBase};
    }
  `}
  ${(props: StyledTrendingTabProps) =>
    !props.isActive &&
    `
    border: 1px solid #E4E8EC;
    p {
      color: ${theme.colors.gray600};
    }
  `}
`

export const StyledTrendingTabTitle = styled.p`
  font-weight: 600;
  ${MediaQueries.mbUp} {
    font-size: 16px;
    line-height: 24px;
  }

  ${MediaQueries.mbDown} {
    font-size: 14px;
    line-height: 22px;
    letter-spacing: -0.2px;
  }
`
export const StyledTrendingTabIcon = styled.img`
  width: 24px;
  height: 24px;
`

export const StyledSectionContainer = styled(Container)`
  padding-left: ${rem(21)};
  padding-right: ${rem(21)};
  ${MediaQueries.mbDown} {
    padding: 0;
  }
`
